import angular from 'angular'

import AvatarMultiComponent from './vd-avatar-multi.component'

angular.module('vend.ui').component('vdAvatarMulti', AvatarMultiComponent)
